export default __webpack_public_path__ + "static/icon-tile-dark-3b165836b9823c1f3489705516b8b2bc.png";